import React, { useState } from 'react';
import {
    makeStyles,
    Grid,
    Typography,
    Button,
    Dialog,
    DialogContent,
    Select,
    MenuItem
} from '@material-ui/core';


const MassChangeRoleDialog = (props) => {

    const useStyles = makeStyles((theme) => ({
        createUserButton: {
            width: 165,
            fontSize: 16,
            fontWeight: 600,
            backgroundColor: '#af001e',
            color: 'white',
            borderRadius: 0,
            '&:hover': {
                backgroundColor: '#af001eA5',
            }
        },
        dialogZ: {
            zIndex: 3000
        }
    }));

    const classes = useStyles();
    const [roleIds, setRoleIds] = useState("");
    const {
        roles,
        massRoleDialog,
        handleToggleMassRoleDialog,
        changeRoleSelectedUsers
    } = props;

    return (
        <Dialog
            PaperProps={{
                style: {
                    borderRadius: 0,
                    padding: 20
                }
            }}
            maxWidth="xs"
            open={massRoleDialog}
            onClose={handleToggleMassRoleDialog}
            disableBackdropClick
            keepMounted>
            <DialogContent>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Typography style={{ color: '#3e3f60', fontSize: 30, fontWeight: 600 }}>Change Users Role</Typography>
                    </Grid>
                    <Grid item>
                        <Grid container direction="column">
                            <Grid item>
                                <Typography>Role</Typography>
                            </Grid>
                            <Grid item>
                                <Select
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    value={roleIds ? roleIds : false}
                                    onChange={(e) => {
                                        setRoleIds(e.target.value)
                                    }}
                                    style={{
                                        borderRadius: 0,
                                        borderColor: '#c6c9db'
                                    }}>
                                    <MenuItem value={false} selected disabled>Select Role</MenuItem>
                                    {
                                        roles && roles.length > 0 && roles.map((role, key) => (
                                            <MenuItem key={key} value={role.id}>{role.display_name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" alignItems="flex-start">
                            <Grid item>
                                <Button fullWidth size="large" className={classes.createUserButton} onClick={() => {
                                    changeRoleSelectedUsers(roleIds);
                                    setRoleIds('');
                                }} color="primary">
                                    Update
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button fullWidth style={{ color: '#3e3f60', fontSize: 16, fontWeight: 600, width: 168 }} size="large" onClick={() => {
                                    setRoleIds('');
                                    handleToggleMassRoleDialog();
                                }} color="primary">
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default MassChangeRoleDialog;
